import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.stressSituation.loading;
export const selectErrorMessage = (state: RootState) =>
  state.stressSituation.error;
export const stressSituationDataResponse = (state: RootState) =>
  state.stressSituation.stressSituationResponse;
